import React, { useEffect, useState } from "react";
import pestimage from "assets/img/SPB_main.jpg";
import highlightsimage from "assets/img/IDSurvey_2022_highlights_map.jpg";
import resourcesimage from "assets/img/additional-resources-2024.png";
import Hero from "../Hero/Hero.jsx";
import AllTreeMortality from "./AllTreeMortality.jsx";
import "./NationalReports.css";

function NationalReports() {
  const [announcement, setAnnouncement] = useState("");

  // Initial load
  useEffect(() => {
    window.scroll(0, 0);
    setAnnouncement("You are now on the National Reports page");
    document.title = "Forest Pest Conditions - National Report";
  }, []);

  return (
    <>
      <Hero value="National Reports" />
      <main className="grid-container national-reports" id="main-content">
        <div className="grid-row">
          <div className="grid-column">
            <h1 className="main-heading">
              Forest Insect and Disease Conditions
            </h1>
          </div>
        </div>
        <div className="visually-hidden" aria-live="polite">
          {announcement}
        </div>
        <AllTreeMortality />
        <hr className="mobile-disappear" />
        <div className="grid-row">
          <h2>
            Major Forest Insect and Disease Conditions in the United States
          </h2>
          <div className="grid-row">
            <div className="national-reports-section tablet:grid-col-6 mobile-lg:grid-col-12 text-center">
              <img
                src={pestimage}
                width="100%"
                id="beetle-image"
                alt="Southern pine beetle in flight"
              ></img>
              <b>Southern pine beetle in flight</b>
              <div>Photo: USDA Forest Service, FHAAST</div>
            </div>
            <div className="national-reports-section margin-left tablet:grid-col-6 mobile-lg:grid-col-12">
              <p>
                The annual forest conditions report provides information
                generated through the combined efforts of U.S. Department of
                Agriculture (USDA), Forest Service employees; State agencies;
                and other partners. Their dedication to the monitoring,
                detection, suppression, treatment, and management of our
                forested lands for insects and disease makes this report
                possible.
              </p>
              <p>
                <a
                  href="https://www.fs.usda.gov/science-technology/forest-health-protection/publications-reports/forest-health-protection-publications"
                  title="Forest Health Protection Publications website"
                  target="_blank"
                  rel="noreferrer"
                  className="usa-link"
                >
                  Visit the Forest Health Protection Publications website for
                  the latest condition report
                </a>
              </p>
            </div>
          </div>
        </div>
        <hr className="mobile-disappear" />
        <div className="grid-row">
          <h2>National Highlights of Tree Mortality</h2>
        </div>
        <div className="grid-row">
          <div className="national-reports-section margin-right tablet:grid-col-6 mobile-lg:grid-col-12">
            <p>
              Forest Health Protection highlights of tree mortality and other
              damage from insects and diseases. Approximately 500 million acres
              surveyed annually.
            </p>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.fs.usda.gov/science-technology/data-tools-and-products/fhp-mapping-reporting/detection-surveys"
              title="Visit website with additional National Insect and Disease Detection Survey maps"
              className="usa-link"
            >
              View additional National Insect and Disease Detection Survey maps
            </a>
          </div>
          <div className="national-reports-section tablet:grid-col-6 mobile-lg:grid-col-12 text-center">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.fs.usda.gov/foresthealth/applied-sciences/mapping-reporting/detection-surveys.shtml#idsmaps"
              title="Visit website with additional National Insect and Disease Detection Survey maps"
            >
              <img
                src={highlightsimage}
                id="img1"
                alt="2022 National Forest Insect and Disease Detection Survey Map"
              />
            </a>
          </div>
        </div>
        <hr className="mobile-disappear" />
        <div className="grid-row">
          <h2>Additional Resources</h2>
        </div>
        <div className="grid-row">
          <div className="national-reports-section additional-resources tablet:grid-col-6 mobile-lg:grid-col-12 text-center">
            <a
              href="https://www.fs.usda.gov/science-technology/forest-health-protection"
              target="_blank"
              rel="noreferrer"
              title="Visit Forest Health Protection website"
            >
              <img
                src={resourcesimage}
                id="addtional-resources"
                alt="Screenshot of Forest Health Protection website"
              />
            </a>
          </div>
          <div className="national-reports-section margin-left tablet:grid-col-6 mobile-lg:grid-col-12">
            <p>
              We have over 150 specialists in the areas of forest entomology,
              forest pathology, invasive plants, pesticide use, survey and
              monitoring, suppression and control, assessment and applied
              sciences, and other forest health-related services.
            </p>
            <p>
              <a
                href="https://www.fs.usda.gov/science-technology/forest-health-protection"
                target="_blank"
                className="usa-link"
                rel="noreferrer"
                title="Visit Forest Health Protection website"
              >
                Forest Health Protection website
              </a>
            </p>
            <p>
              In addition to the Forest Health Protection (FHP) program, other
              USDA Forest Service programs and offices monitor, model, and
              research forest health-related issues. These programs and offices
              work together with FHP to address threats to our nation's forests
              comprehensively. Check out the links below to learn more:
            </p>
            <p>
              <a
                href="https://www.fs.usda.gov/managing-land/fire/resilient-landscapes"
                target="_blank"
                className="usa-link"
                rel="noreferrer"
                title="Visit USFS Fire and Aviation Management website"
              >
                USFS Fire and Aviation Management website
              </a>
              <br />
              <a
                href="https://www.fs.usda.gov/managing-land/sustainability-and-climate/data-dashboard"
                target="_blank"
                className="usa-link"
                rel="noreferrer"
                title="Visit USFS Office of Sustainability and Climate website"
              >
                USFS Office of Sustainability and Climate website
              </a>
              <br />
              <a
                href="https://fia-usfs.hub.arcgis.com/"
                target="_blank"
                className="usa-link"
                rel="noreferrer"
                title="Visit USFS Forest Inventory and Analysis website"
              >
                USFS Forest Inventory and Analysis website
              </a>
              <br />
              <a
                href="https://research.fs.usda.gov/pnw/centers/wwetac"
                target="_blank"
                className="usa-link"
                rel="noreferrer"
                title="Visit the USFS Western Wildland Environmental Threat Assessment Center website"
              >
                USFS Western Wildland Environmental Threat Assessment Center
              </a>
              <br />
              <a
                href="https://research.fs.usda.gov/centers/efetac"
                target="_blank"
                className="usa-link"
                rel="noreferrer"
                title="Visit the USFS Eastern Forest Environmental Threat Assessment Center website"
              >
                USFS Eastern Forest Environmental Threat Assessment Center
              </a>
            </p>
          </div>
        </div>
      </main>
    </>
  );
}

export default NationalReports;
